import { atom } from 'recoil';

export const modalAtom = atom({
  key: 'MODAL_ATOM',
  default: {
    isOpen: false,
    content: null,
  },
});
